/**
 * Dot colors for ticket properties, on the same grammar as the resolver state in the chat
 * header: violet = being worked, orange = needs a person, muted red = escalated or urgent,
 * muted green = done, neutral = everything else. PSAs word status differently, so status
 * is matched by keyword rather than by exact value.
 */
import { NEUTRAL, ORANGE, VIOLET } from "../../styles/brandTokens";

/** Muted green and red: the brand has no tokens for either, so they are toned to sit by plum. */
export const DOT_DONE = "#6BAA76";
export const DOT_ALERT = "#D86A6A";

const STATUS_RULES: ReadonlyArray<{ pattern: RegExp; color: string }> = [
  { pattern: /escalat/, color: DOT_ALERT },
  { pattern: /complete|closed|resolved|done/, color: DOT_DONE },
  { pattern: /wait|pending|hold/, color: ORANGE.main },
  { pattern: /progress|working|assigned/, color: VIOLET.main },
];

const PRIORITY_COLORS: Readonly<Record<string, string>> = {
  critical: DOT_ALERT,
  high: ORANGE.main,
  medium: ORANGE.soft,
  low: NEUTRAL.borderStrong,
};

export function statusDotColor(status?: string | null): string {
  const normalized = String(status || "").toLowerCase();
  const rule = STATUS_RULES.find(({ pattern }) => pattern.test(normalized));
  return rule ? rule.color : NEUTRAL.borderStrong;
}

export function priorityDotColor(priority?: string | null): string {
  return PRIORITY_COLORS[String(priority || "").trim().toLowerCase()] ?? NEUTRAL.borderStrong;
}

/** "in progress" => "In Progress". */
export function formatPropertyLabel(value?: string | null): string {
  return String(value || "")
    .trim()
    .split(/\s+/)
    .filter(Boolean)
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(" ");
}
